"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTableStyles = exports.tableVars = exports.tableCommon = exports.getTableBorderStyles = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var tableCommon = exports.tableCommon = ["width", "height", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft"].concat(_toConsumableArray(_commonProps.defaultCommonProps));
var tableVars = exports.tableVars = (0, _initVars.default)({
  applied: [].concat(_toConsumableArray(tableCommon), ["tableLayout"]),
  variables: [{
    key: "cellPadding",
    defaultUnit: "px"
  }]
});
var getTableBorderStyles = exports.getTableBorderStyles = function getTableBorderStyles(classes, border) {
  if (border === "none") {
    return [];
  }
  return border.map(function (item) {
    return classes["".concat(item, "Border")];
  });
};
var styles = function styles(theme) {
  return {
    variables: tableVars.styles,
    table: {
      position: "relative",
      fontFamily: theme.typography.fontFamily,
      minWidth: "100%",
      boxSizing: "border-box",
      borderCollapse: "collapse",
      borderWidth: 1,
      borderColor: theme.colors.baseContrast040,
      "& td": {
        borderWidth: 1,
        borderColor: theme.colors.baseContrast040
      },
      "&:hover > caption": {
        opacity: 1
      }
    },
    striped: {
      "& tr": {
        "&:nth-child(even)": {
          background: theme.colors.baseContrast015,
          "&:hover": {
            background: theme.colors.baseContrast020
          }
        }
      }
    },
    highlightOnHover: {
      "& tr": {
        "&:hover": {
          background: theme.colors.baseContrast020
        }
      }
    },
    horizontalBorder: {
      borderTopStyle: "hidden",
      borderBottomStyle: "none",
      "& th, & td": {
        borderTopStyle: "solid",
        borderBottomStyle: "none"
      }
    },
    verticalBorder: {
      borderRightStyle: "hidden",
      borderLeftStyle: "hidden",
      borderBottomStyle: "hidden",
      "& th, & td": {
        borderRightStyle: "solid",
        borderLeftStyle: "solid"
      }
    },
    outerBorder: {
      borderStyle: "solid"
    },
    thead: {
      textTransform: "capitalize",
      fontSize: 14,
      fontWeight: 600
    },
    tbody: {
      "& td": {
        padding: tableVars.get("cellPadding", "".concat(theme.spacing.base, "px ").concat(theme.spacing.base * 2, "px")),
        color: theme.colors.baseContrast085
      }
    },
    tableFullWidth: {
      width: "100%",
      maxWidth: "100%"
    }
  };
};
var useTableStyles = exports.useTableStyles = (0, _createUseStyles.default)(styles, {
  name: "Table"
});